import { IComponentOptions } from 'angular';
import { RegentsPlanningWizardTransferCtrl } from './regents-planning-wizard-transfer.controller';

export const RegentsPlanningWizardTransferComponent: IComponentOptions = {
  bindings: {
    currentSchool: '<',
    currentUser: '<',
  },
  controller: RegentsPlanningWizardTransferCtrl,
  template: require('./regents-planning-wizard-transfer.html'),
};
